import React from "react";
import PropTypes from "prop-types";
import styles from "./PlatformIcon.module.css";
import { ReactComponent as LaptopIcon} from "../../assests/laptop-icon.svg";
import { ReactComponent as AppleIcon} from "../../assests/apple-icon.svg";
import { ReactComponent as AndroidIcon} from "../../assests/android-icon.svg";

const PLATFORM_ICONS = {
  Web: LaptopIcon,
  iOS: AppleIcon,
  Android: AndroidIcon,
};

// Map friendly translations
const PLATFORM_DISPLAY_MAP = {
  PC: "Web",
  Apple: "iOS",
  Android: "Android",
  Web: "Web",
  iOS: "iOS",
};

/**
 * View component. An icon that displays a compatible platform for a feed.
 */
export function PlatformIcon({ platformType }) {
  // Sanitize the incoming platformType
  const displayPlatformType = PLATFORM_DISPLAY_MAP[platformType] || "Web";
  const SafeIcon = PLATFORM_ICONS[displayPlatformType] || LaptopIcon;

  if (!PLATFORM_ICONS[displayPlatformType]) {
    console.warn(
      `Unknown platformType "${platformType}" received, defaulting to "Web".`
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <SafeIcon className={styles.icon} />
      </div>
    </div>
  );
}

PlatformIcon.propTypes = {
  platformType: PropTypes.oneOf(["Web", "iOS", "Android", "PC", "Apple"]), // Update to handle raw AND mapped types (e.g., "Apple" & "PC")
};
